import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config.service';
import { GoogleAnalyticsService } from './google-analytics-service';
import { AnalyticsItem, AnalyticsTransaction } from './interface';

@Injectable()
export class AnalyticsService {
  constructor(private configService: AppConfigService, private googleAnalyticsService: GoogleAnalyticsService) {
    this.configService.config$.subscribe((config) => {
      this.googleAnalyticsService.initialize(config.googleAnalyticsCode, config.googleAnalyticsDimensions);
    });
  }

  track(event: string, action: string, label: string): void {
    this.googleAnalyticsService.trackEvent(event, action, label);
  }

  trackEcommerceTransaction(transaction: AnalyticsTransaction, items: AnalyticsItem[]): void {
    (items || []).forEach((item) => this.googleAnalyticsService.addEcommerceItem(item));
    this.googleAnalyticsService.startEcommerceTransaction(transaction);
    this.googleAnalyticsService.sendEcommerceEvent('Checkout');
  }
}
